function number(value, digits = 2) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed.toLocaleString("zh-CN", { maximumFractionDigits: digits, minimumFractionDigits: digits }) : "--";
}

function signed(value, digits = 2) {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return "--";
  return `${parsed > 0 ? "+" : ""}${parsed.toFixed(digits)}%`;
}

function tone(value, styles) {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed === 0) return styles.flat;
  return parsed > 0 ? styles.up : styles.down;
}

// trade_date carries either an ISO date to shorten for display ("2026-07-27" →
// "07-27") or a literal state word the overlay chose ("实时" / "收盘"). Slicing
// blindly turned the latter into an empty label, so the card showed a bare
// percentage with nothing saying what it was.
function dateOrLabel(value) {
  if (!value) return "";
  return value.includes("-") ? value.slice(5) : value;
}

export function IndexCard({ item, onOpen, styles }) {
  if (item.status === "unavailable") {
    return (
      <article className={`${styles.indexCard} ${styles.unavailableCard}`}>
        <div><strong>{item.name}</strong><small>{item.code}</small></div>
        <span>暂无真实行情</span>
      </article>
    );
  }
  return (
    <article className={`${styles.indexCard} ${styles.clickableCard}`} onClick={onOpen} role="button" tabIndex={0} onKeyDown={(event) => event.key === "Enter" && onOpen()}>
      <div className={styles.indexCardHeader}><strong>{item.name}</strong><small>{item.code}</small></div>
      <div className={styles.indexValue}>{number(item.close)}</div>
      <div className={styles.indexChanges}>
        <span className={tone(item.pct_chg, styles)}>{dateOrLabel(item.trade_date)} {signed(item.pct_chg)}</span>
        <span className={tone(item.pct_chg_5d, styles)}>5日 {signed(item.pct_chg_5d)}</span>
      </div>
    </article>
  );
}

export function StatusBadge({ status, dataDate, styles }) {
  const labels = {
    ok: "数据完整",
    provisional: "初步 · 今夜校准",
    live: "实时 · 已落库",
    closed_complete: "最近收盘完整",
    partial: "部分可用",
    stale: "实时已过期",
    missing: "实时未落库",
    unavailable: "数据不可用",
  };
  const label = labels[status] ?? "状态未知";
  return (
    <span className={`${styles.statusBadge} ${styles[status] ?? ""}`}>
      <span />{label}{dataDate ? ` · ${dataDate}` : ""}
    </span>
  );
}

export function BreadthMini({ item, styles }) {
  if ([item.rise, item.flat, item.fall].every((value) => value === null || value === undefined)) {
    return <span className={styles.flat}>--</span>;
  }
  const total = Number(item.rise || 0) + Number(item.flat || 0) + Number(item.fall || 0) || 1;
  return (
    <div className={styles.breadthMini} title={`上涨 ${item.rise} · 平盘 ${item.flat} · 下跌 ${item.fall}`}>
      <span className={styles.riseSegment} style={{ width: `${Number(item.rise || 0) / total * 100}%` }} />
      <span className={styles.flatSegment} style={{ width: `${Number(item.flat || 0) / total * 100}%` }} />
      <span className={styles.fallSegment} />
    </div>
  );
}
